import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __ANPR_PERSON_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';

interface NotProfessionalConditionListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (notProfessionalCondition?: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

type Key = {
  codice: string;
};

interface NotProfessionalCondition {
  key: Key;
  descrizione: string;
}

const NotProfessionalConditionListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Condizione non professionale',
  id = 'notProfessionalCondition',
}: NotProfessionalConditionListComponentProps): React.ReactElement => {
  const [notProfessionalCondition] = useHttpFetch<
    HttpResponseList<NotProfessionalCondition>,
    Array<ItemVM>
  >(`${__ANPR_PERSON_API_URL__}/condizione-non-professionale`, {
    onBootstrap: true,
    initialData: [],
    transformer: (response: AxiosResponse<HttpResponseList<NotProfessionalCondition>>) => {
      const { data } = response;

      return data?.payload.list.map((item) => ({
        id: item.key.codice,
        value: item.descrizione,
      })) as Array<ItemVM>;
    },
  });

  const list = (notProfessionalCondition.data as Array<ItemVM>) || [];

  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

NotProfessionalConditionListComponent.displayName = 'Not Professional Condition List component';

const NotProfessionalConditionList = memo(NotProfessionalConditionListComponent);

export default NotProfessionalConditionList as typeof NotProfessionalConditionListComponent;
